module.exports = __webpack_public_path__ + "fonts/dFa5ZfeM_74wlPZtksIFYoEf6H2pW3pwfa3Efg.woff2";